<template>
    <section class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
            <h2 class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">{{ t('pages.features.title') }}
            </h2>
            <p class="mt-6 text-lg leading-8 text-white/50">{{ t('pages.features.subtitle') }}</p>
        </div>

        <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            <!-- Image Comparison Card -->
            <div class="flex flex-col items-start justify-between">
                <ComparisonSlider before-media-src="/idx/png_video_faceswap_after.png"
                    after-media-src="/idx/png_video_faceswap_before.png"
                    before-alt="After AI face swap: woman turned into man in video"
                    after-alt="Before face swap: original woman in video">
                </ComparisonSlider>
                <div class="max-w-xl">
                    <div class="group relative">
                        <h3 class="mt-4 text-xl font-semibold leading-6 text-white">{{ t('pages.features.video.title') }}</h3>
                        <p class="mt-2 line-clamp-3 text-md leading-6 text-white/50">{{ t('pages.features.video.description') }}</p>
                    </div>
                </div>
            </div>

            <!-- GIF/WEBP Comparison Card -->
            <div class="flex flex-col items-start justify-between">
                <ComparisonSlider before-media-src="/idx/png_photo_faceswap_after.jpg"
                    after-media-src="/idx/png_photo_faceswap_before.jpg"
                    before-alt="After AI face swap: woman turned into man in photo"
                    after-alt="Before face swap: original woman in photo">
                </ComparisonSlider>
                <div class="max-w-xl">
                    <div class="group relative">
                        <h3 class="mt-4 text-xl font-semibold leading-6 text-white">{{ t('pages.features.photo.title') }}</h3>
                        <p class="mt-2 line-clamp-3 text-md leading-6 text-white/50">{{ t('pages.features.photo.description') }}</p>
                    </div>
                </div>
            </div>

            <!-- Image Comparison Card 2 -->
            <div class="flex flex-col items-start justify-between">
                <ComparisonSlider before-media-src="/idx/png_multiple_faceswap_after.jpg"
                    after-media-src="/idx/png_multiple_faceswap_before.jpg"
                    before-alt="After AI face swap: group photo with gender-swapped faces"
                    after-alt="Before face swap: group photo with men and women">
                </ComparisonSlider>
                <div class="max-w-xl">
                    <div class="group relative">
                        <h3 class="mt-4 text-xl font-semibold leading-6 text-white">{{ t('pages.features.multiple.title') }}</h3>
                        <p class="mt-2 line-clamp-3 text-md leading-6 text-white/50">{{ t('pages.features.multiple.description') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-12 w-full flex justify-center">
            <FaceSwapBtn></FaceSwapBtn>
        </div>
    </section>
</template>
<script setup lang="ts">
import FaceSwapBtn from './FaceSwapBtn.vue';
import ComparisonSlider from './ComparisonSlider.vue';

const { t } = useI18n();
</script>